import { cn } from '@/presentation/utils'
import * as React from 'react'
import { useFormField } from './field'
import { useGetError } from './useGetError'

export const FieldMessage = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  const { id, path } = useFormField()
  const error = useGetError(path)
  const formMessageId = `${id}-form-item-message`

  const body = error ? String(error?.message) : children

  if (!body) {
    return null
  }

  return (
    <p
      ref={ref}
      id={formMessageId}
      className={cn('text-[0.8rem] font-medium text-destructive', className)}
      {...props}
    >
      {body}
    </p>
  )
})

FieldMessage.displayName = 'FieldMessage'
